export type Primitive = number | string | boolean | null;

export function isPrimitive(o: unknown): o is Primitive {
	const t = typeof o;
	switch (t) {
		case "number":
		case "string":
		case "boolean":
			return true;
	}

	if (o === null) {
		return true;
	}

	return false;
}
